/** @format */

const ls = typeof window !== 'undefined' && window.localStorage
// TODO: find a better way to do this memberId stuff...
const memberId =
  typeof window !== 'undefined' && window.hs && window.hs.memberId

export const get = (key, fallback) =>
  (ls && ls.getItem(`${memberId || 'MEMBER'}.${key}`)) || fallback
